import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeColors } from 'msp-components';
import { rem } from 'utils/text';
import { Helmet } from 'react-helmet';

const StyledContainer = styled.div`
  align-items: center;
  border: 1px solid ${themeColors.grayNickel};
  border-top: none;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  color: ${themeColors.bodyColor};
  font-size: ${rem(16)};
`;

const StyledHeader = styled.header`
  color: ${themeColors.headingColor};

  h1 {
    font-size: ${rem(36)};
    margin: 0;
  }
`;

const Error500 = ({ onLoad }) => {
  useEffect(() => onLoad && onLoad(), [onLoad]);

  return (
    <StyledContainer>
      <Helmet>
        <title>Error</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <StyledHeader>
        <h1 className="mb-3">Oops...</h1>
      </StyledHeader>
      <p>
        {/* eslint-disable-next-line */}
        We’re sorry, but we seem to have encountered an error. <a href="">Refresh the page</a> to try again.
      </p>
    </StyledContainer>
  );
};

Error500.propTypes = {
  onLoad: PropTypes.func,
};

export default Error500;
